<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
			</div>
		</div>
		<div class="analytics-portlet-content creative-performance-div {{ sectionclass }}">
			<div class="creative-performance-area">
				<div *ngIf="!hasData">
					<img *ngIf="!isR8" [src]="placeholderimage" class="no-creative-data" />
					<div *ngIf="isR8" class="creative-nodata-text">No Data to Display</div>
				</div>

				<div *ngIf="hasData">
					<div class="performance-graph-area">
						<app-creative-performance-graph
							[sectiontitle]="sectiontitle"
							[legendData]="legend"
							[graphData]="graphData"
							[name]="'creative_' + key"
							(legendSelected)="processSelectedLegendItem($event)"
							(mouseOutChart)="chartHover($event)"
							[chartType]="chartType"
							[markerEnabled]="markerEnabled"
							[markerEnabled]="true"
							(mouseOverChart)="chartHover($event)"
						></app-creative-performance-graph>
					</div>
					<div class="carousel-area">
						<div class="creative-performance-stats">
							<ngu-carousel #carousel [inputs]="carouselOne" [dataSource]="sortedCreatives">
								<ngu-tile NguCarouselItem *nguCarouselDef="let creativeData; let i = index">
									<div *ngIf="isR8" class="creative-name">
										<span>{{ creativeData.creativeName ? creativeData.creativeName : creativeData?.adHeadline ? creativeData?.adHeadline : ''}}</span>
										<span>{{i + 1}} of {{sortedCreatives.length}} creatives</span>
									</div>
									<app-creative-performance-stats
										[dateRange]="range"
										[creative]="creativeData"
										[creativeIndex]="i"
										[showStats]="true"
										(previewCreativeEvent)="previewCreative($event)"
										[producttype]="producttype"
									></app-creative-performance-stats>
								</ngu-tile>
								<button *ngIf="sortedCreatives.length > 1" NguCarouselPrev class="leftRs">&lt;</button>
								<button *ngIf="sortedCreatives.length > 1" NguCarouselNext class="rightRs">&gt;</button>
								<ul class="carousel-points-container myPoint" NguCarouselPoint>
									<li
										*ngFor="let j of carousel.pointNumbers; let k = index"
										[class.active]="j == carousel.activePoint"
										(click)="movetoNextCarousel(k)"
									></li>
								</ul>
							</ngu-carousel>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal id="creative-preview-v1_{{ key }}">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeCreativePreview('creative-preview-v1_' + key)"
		[producttype]="producttype"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
